// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"918f6c63","243":"cf85856f","970":"b3c33f94"}[chunkId] + ".chunk.js";
};